// Styles
import 'reset-css';
// import './node_modules/spinkit/spinkit.css';
import "./index.scss";

// Scripts
import "./tools/tools.js";
// import "./scripts/scripts.js";
import "./template/layout/layout.js";
import "./template/components/components.js";

import marquee from 'vanilla-marquee';

new marquee( document.getElementById( 'marquee' ), {
  duplicated: true,
  gap:        0,
  speed:      50,
  startVisible:      true,
});